import httpUtils from '../../utils/HttpUtils'

class ArticleService {

  //获取文章列表信息
  async list(subCategoryIdArray = [],subCategoryId = '',keyword = '',pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/cms/article/list',{subCategoryIdArray,subCategoryId,keyword,pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }

  //获取文章列表信息
  async categoryList(subCategoryIdArray = '') {
    let result = null;
    try {
      let level = 2;
      result = await httpUtils.post('/cms/category/list',{level,subCategoryIdArray})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }


  //获取文章详情信息
  async detail(id = '') {
    let result = null
    try {
      result = await httpUtils.get('/cms/article/detail',{id})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }
}
export default new ArticleService()
